import { IAppState } from '@myStore/app.state';
import { IGroupsChangesState } from '@myStore/groups-changes/groups-changes.state';
import { createSelector } from '@ngrx/store';

const groupsChangesSelector = (state: IAppState) => state.groupsChanges;

export const selectChangesGroupLoading = createSelector(
  groupsChangesSelector,
  (state: IGroupsChangesState) => state?.isLoading
);

export const selectChangesGroupSuccess = createSelector(
  groupsChangesSelector,
  (state: IGroupsChangesState) => state?.success
);

export const selectChangesGroupFailure = createSelector(
  groupsChangesSelector,
  (state: IGroupsChangesState) => state?.errors
);

export const selectAddAdminsToTGGroupLoading = createSelector(
  groupsChangesSelector,
  (state: IGroupsChangesState) => state?.telegramGroup.isLoading
);

export const selectAddAdminsToTGGroupSuccess = createSelector(
  groupsChangesSelector,
  (state: IGroupsChangesState) => state?.telegramGroup.success
);

export const selectAddAdminsToTGGroupFailure = createSelector(
  groupsChangesSelector,
  (state: IGroupsChangesState) => state?.telegramGroup.errors
);

export const selectChangesAttentionsESDPTrue = createSelector(
  groupsChangesSelector,
  (state: IGroupsChangesState) => state?.attentionESDPGroup
);
export const selectChangesAttentionsESDPFalse = createSelector(
  groupsChangesSelector,
  (state: IGroupsChangesState) => state?.attentionESDPGroup
);
